import React, {PropsWithChildren, useEffect} from 'react';
import {Drawer as PathDrawer} from '@ellucian/react-design-system/core';
import {DrawerProps} from '@mui/material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faXmark} from '@fortawesome/pro-solid-svg-icons';
import {useLocation} from 'react-router-dom';

import UnstyledButton from '../unstyled-button';

import './drawer.scss';

interface Props extends Omit<DrawerProps, 'onClose'> {
  onClose: () => void;
}

const EllucianDrawer = ({children, onClose, ...drawerProps}: Props & PropsWithChildren) => {
  const location = useLocation();

  useEffect(() => {
    onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <PathDrawer classes={{paper: 'ellucian-drawer'}} onClose={onClose} {...drawerProps}>
      <UnstyledButton className="ellucian-drawer-close" onClick={onClose}>
        <FontAwesomeIcon icon={faXmark} />
      </UnstyledButton>
      {children}
    </PathDrawer>
  );
};

export default EllucianDrawer;
